/**
 * Recherche exclusive par marque : si le terme tapé correspond exactement
 * à une marque listée dans les réglages du thème (Recherche > Marques à recherche exclusive),
 * renvoie une requête limitée au fournisseur, sinon null.
 */
// Ignore accents, apostrophes, case and extra spaces: "kérastase" = "Kerastase", "l'oreal" = "loreal"
window.normalizeBrandTerm = function (value) {
  return (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’‘`´]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
};

/**
 * Une ligne par marque dans le réglage :
 *   Fournisseur
 *   variante 1, variante 2 = Fournisseur
 *   variante 1, variante 2 = Fournisseur A | Fournisseur B   (regroupe plusieurs fournisseurs)
 * Renvoie la liste des fournisseurs correspondant au terme tapé, ou null.
 */
window.getBrandVendors = function (term) {
  const normalize = window.normalizeBrandTerm;
  const normalizedTerm = normalize(term);
  if (!normalizedTerm) return null;

  const lines = (window.brandSearchTerms || []).map((line) => line.trim()).filter(Boolean);
  for (const line of lines) {
    const separator = line.indexOf('=');
    const vendors = (separator === -1 ? line : line.slice(separator + 1))
      .split('|')
      .map((vendor) => vendor.trim())
      .filter(Boolean);
    if (!vendors.length) continue;

    const aliases = separator === -1 ? [] : line.slice(0, separator).split(',');
    if (vendors.length === 1) aliases.push(vendors[0]);

    if (aliases.some((alias) => normalize(alias) === normalizedTerm)) return vendors;
  }

  // Tout fournisseur de la boutique est aussi reconnu automatiquement par son nom exact
  // (accents, apostrophes et majuscules ignorés). « moons » et « My Store » sont exclus.
  const excludedVendors = ['moons', 'my store'];
  const vendorMatch = (window.shopVendors || []).find((vendor) => {
    const key = normalize(vendor);
    return key && !excludedVendors.includes(key) && key === normalizedTerm;
  });
  if (vendorMatch) return [vendorMatch];

  return null;
};

window.getBrandSearchQuery = function (term) {
  const vendors = window.getBrandVendors(term);
  return vendors ? vendors.map((vendor) => `vendor:"${vendor}"`).join(' OR ') : null;
};

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('submit', this.onBrandSubmit.bind(this));
      window.addEventListener('pageshow', this.restoreBrandInput.bind(this));
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  onBrandSubmit(event) {
    if (event.defaultPrevented) return;
    const brandQuery = window.getBrandSearchQuery(this.input.value);
    if (!brandQuery) return;

    const form = this.input.form;
    let hiddenInput = form.querySelector('input[data-brand-query]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'q';
      hiddenInput.setAttribute('data-brand-query', '');
      form.appendChild(hiddenInput);
    }
    hiddenInput.value = brandQuery;
    this.input.removeAttribute('name');
  }

  restoreBrandInput() {
    if (!this.input) return;
    this.input.setAttribute('name', 'q');
    this.input.form.querySelector('input[data-brand-query]')?.remove();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
